import React from 'react';
import { motion } from 'framer-motion';
import { User, Phone, Mail, MapPin, Heart, History, CheckSquare, Star, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const fieldIcons = [User, Phone, Mail, MapPin, Heart, History, CheckSquare, Star];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: 'easeOut', delay },
});

export default function DataRemarketing() {
  const { t } = useLanguage();
  const d = t.data;

  return (
    <section className="py-14 md:py-20 bg-[#1F2833]" data-testid="data-section">
      <div className="section-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: content */}
          <motion.div {...fadeUp()}>
            <div className="divider-gold" />
            <h2 className="heading-lg mb-5">{d.title}</h2>
            <p className="text-[#8A9099] text-base leading-relaxed mb-8">{d.body}</p>
            <p className="text-[#F3F1EB]/80 text-sm leading-relaxed">{d.commercial}</p>
          </motion.div>

          {/* Right: funnel visual */}
          <motion.div {...fadeUp(0.2)}>
            {/* Funnel simulation */}
            <div className="relative">
              {/* Top: Anonymous fans */}
              <div className="text-center mb-4">
                <div className="inline-flex items-center gap-2 bg-[#1A222B] rounded-full px-5 py-2.5 border border-white/10">
                  <div className="flex -space-x-2">
                    {[...Array(4)].map((_, i) => (
                      <div key={i} className="w-6 h-6 rounded-full bg-[#8A9099]/30 border border-[#8A9099]/20 flex items-center justify-center">
                        <User size={10} className="text-[#8A9099]" />
                      </div>
                    ))}
                  </div>
                  <span className="text-[#8A9099] text-sm">Fans anónimos</span>
                </div>
              </div>

              {/* Arrow */}
              <div className="flex justify-center mb-4">
                <div className="w-px h-8 bg-gradient-to-b from-[#8A9099]/30 to-[#D5A63B]/60" />
              </div>

              {/* MatchPool.live */}
              <div className="text-center mb-4">
                <div className="inline-flex items-center gap-2 bg-[#0F6B49]/20 border border-[#0F6B49]/40 rounded-xl px-6 py-3">
                  <ArrowRight size={16} className="text-[#D5A63B]" />
                  <span className="text-[#D5A63B] font-bold font-exo italic">MatchPool.live</span>
                  <ArrowRight size={16} className="text-[#D5A63B]" />
                </div>
              </div>

              {/* Arrow */}
              <div className="flex justify-center mb-4">
                <div className="w-px h-8 bg-gradient-to-b from-[#D5A63B]/60 to-[#0F6B49]/60" />
              </div>

              {/* Data fields grid */}
              <div className="bg-[#171E26] rounded-2xl border border-[#0F6B49]/30 p-6">
                <div className="text-center mb-4">
                  <span className="text-[#0F6B49] font-bold font-exo italic text-sm">Base de datos propia</span>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  {d.fields.map((field, i) => {
                    const Icon = fieldIcons[i];
                    return (
                      <div key={i} className="flex items-center gap-2 bg-[#1F2833] rounded-lg px-3 py-2">
                        <Icon size={12} className="text-[#D5A63B] flex-shrink-0" />
                        <span className="text-[#F3F1EB] text-xs">{field}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
